"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SignOut = /** @class */ (function () {
    function SignOut(recover) {
        var _this = this;
        this.recover = recover;
        this.sign_out = function () {
            return _this.recover.request("/logout", "POST", {}, null);
        };
    }
    return SignOut;
}());
exports.default = SignOut;
